module.exports = "<p>resumeexam works!</p>\r\n"